<div class="base-dialog" [ngClass]="dialogWidth">
  <nb-card [accent]="status" [size]="size">
    <nb-card-header>
      <div class="header-content">
        <div class="header-title">
          {{ header }}
          @if (tooltip) {
            <nb-icon icon="question-mark-circle-outline" pack="eva" [nbTooltip]="tooltip"></nb-icon>
          }
        </div>
        <ng-content select="[dialog-header-action]"></ng-content>
      </div>
    </nb-card-header>
    <nb-card-body cdkScrollable>
      <ng-content></ng-content>
    </nb-card-body>
    <nb-card-footer>
      <div class="footer-start">
        @if (showCancelButton) {
          <button nbButton
                  status="basic"
                  (click)="cancel()">
            {{ cancelText }}
          </button>
        }
      </div>
      <div class="footer-end">
        <ng-content select="[dialog-footer]"></ng-content>
        @if (showSubmitButton) {
          <button nbButton
                  [disabled]="disableSubmit"
                  [status]="status"
                  (click)="submit()">
            {{ submitText }}
          </button>
        }
      </div>
    </nb-card-footer>
  </nb-card>
</div>
